import { inject, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class WebSocketService {
  location = window.location;
  socket: WebSocket;
  websocketUrl: string = '';

  constructor () {
    if (!this.socket) {
      // let host = "wss://" + location.host;
      this.websocketUrl = "ws";
      let host = this.location.host;
      let port = this.location.port;
      let addPort = !port || (host.indexOf(':' + port) === -1);
      let protocol = this.location.protocol;
      if (protocol = "https") {
        this.websocketUrl += "s://";
      }
      this.websocketUrl += host;
      if (addPort) {
        this.websocketUrl += ":" + port;
      }
      this.socket = new WebSocket(this.websocketUrl);

      this.socket.onopen = function () {
        console.log('WebSocket connected');
      };

      this.socket.onclose = function (event: Event) {
        console.log('WebSocket closed: %s', JSON.stringify(event));
        // if (true) {
        //   this.socket = new WebSocket(this.websocketUrl);
        // }
      };

      this.socket.onmessage = async function (e) {
        let data = await e.data.text();
        var payload = JSON.parse(data);
        console.log('broadcasting:', payload);
        // $rootScope.$broadcast(payload.channel, payload);
      };
    }
  };

  reconnectIfNeeded() {
    if (this.socket.readyState != 1) {
      this.socket = new WebSocket(this.websocketUrl);
    }
  };

  sendMessage(message: any) {
    let dataPackage = JSON.stringify(message);
    console.log('sending:', dataPackage);
    this.reconnectIfNeeded();
    if (this.socket.readyState === 1) {
      this.socket.send(dataPackage);
    }
  };

  registerUser(userId: string) {
    this.reconnectIfNeeded();
    if (this.socket.readyState === 1) {
      this.sendMessage({
        channel: 'registerUser',
        userId: userId
      });
    }
  };

  registerRace(raceId: string) {
    this.reconnectIfNeeded();
    if (this.socket.readyState === 1) {
      this.sendMessage({
        channel: 'registerRace',
        raceId: raceId
      });
    }
  };
}
